import ListSidebar from './ListSidebar';
import FilterContent from './components/FilterContent';

ListSidebar.FilterContent = FilterContent;

export default ListSidebar;
